import { useGeckoLocale } from 'features/locale'
import { GeckoMeasurementUnit } from 'types'

import { WORKING_UNIT_PRESSURE, WORKING_UNIT_THICKNESS } from './ffsUnits'

/**
 * The FFS display units for the active global measurement system — one place that
 * maps each canonical working unit (mm / MPa / mm-yr) to the user's preferred one.
 * Components read whichever they display and pair it with `formatFfs` from
 * `ffsUnits`. Facts with a per-value canonical unit (classification facts, the
 * per-field `FfsParameterField`, the heatmap's CDF-derived axes) resolve their own
 * unit via `useGeckoLocale` directly, since those units are not fixed.
 */
export const useFfsDisplayUnits = (): {
  thickness: GeckoMeasurementUnit
  pressure: GeckoMeasurementUnit
  rate: GeckoMeasurementUnit
} => {
  const { getPreferredMeasurementUnit } = useGeckoLocale()
  return {
    thickness: getPreferredMeasurementUnit(WORKING_UNIT_THICKNESS),
    pressure: getPreferredMeasurementUnit(WORKING_UNIT_PRESSURE),
    rate: getPreferredMeasurementUnit(GeckoMeasurementUnit.MillimetersPerYear),
  }
}
